import { setLastTriggeredTime } from '../actions/conflict';
import * as entriesSelectors from '../selectors/entries';

export default {
  selectors: {
    entries: entriesSelectors,
  },
  actions: {
    conflicts: setLastTriggeredTime,
  },
};
